import { createContext, useContext, useState, useCallback, type ReactNode } from 'react'

interface NotificationsPanelContextValue {
  isOpen: boolean
  openNotificationsPanel: () => void
  closeNotificationsPanel: () => void
  toggleNotificationsPanel: () => void
}

const NotificationsPanelContext = createContext<NotificationsPanelContextValue | null>(null)

export function NotificationsPanelProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)

  const openNotificationsPanel = useCallback(() => setIsOpen(true), [])
  const closeNotificationsPanel = useCallback(() => setIsOpen(false), [])
  const toggleNotificationsPanel = useCallback(() => setIsOpen((prev) => !prev), [])

  const value: NotificationsPanelContextValue = {
    isOpen,
    openNotificationsPanel,
    closeNotificationsPanel,
    toggleNotificationsPanel
  }

  return (
    <NotificationsPanelContext.Provider value={value}>
      {children}
    </NotificationsPanelContext.Provider>
  )
}

export function useNotificationsPanel(): NotificationsPanelContextValue {
  const context = useContext(NotificationsPanelContext)
  if (!context) {
    throw new Error('useNotificationsPanel must be used within NotificationsPanelProvider')
  }
  return context
}
